import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByKey',
})
export class FilterByKeyPipe implements PipeTransform {
  transform(data: any[], key: string, value: string): any {
    return data.filter((item) => item[key] === value.toLowerCase());
  }
}
